window.addEventListener('DOMContentLoaded', (event) => {

  let store_faq = document.querySelector('.faq-item');
  if(store_faq != null){
    // document.querySelector('.faq-item').classList.add('first-faq')
    // document.querySelector('.faq-item').classList.add('active-faq')
    let faq_heading = document.querySelectorAll('.faq-heading')
    faq_heading.forEach(heading => heading.addEventListener('click', e => {
      let parent = e.target.closest('.faq-item')
      let key = parent.dataset.key
  
      faq_heading.forEach(h => {
        let p = h.closest('.faq-item')
        let k = p.dataset.key
        if(k !== key) {
          if(p.classList.contains('active-faq')){
            p.classList.remove('active-faq')
            $(p.querySelector('.faq-details')).slideUp()
          }
        } else{
          p.classList.toggle('active-faq')
          $(p.querySelector('.faq-details')).slideToggle()
        }
      })
    }))
  }
  
  let store_faq_pro = document.querySelector('.faq-item-pro');
  if(store_faq_pro != null){
    let faq_heading_pro = document.querySelectorAll('.faq-heading-pro')
    faq_heading_pro.forEach(heading => heading.addEventListener('click', e => {
      let parent_pro = e.target.closest('.faq-item-pro')
      let key_pro = parent_pro.dataset.key
  
      faq_heading_pro.forEach(h => {
        let p_pro = h.closest('.faq-item-pro')
        let k_pro = p_pro.dataset.key
        if(k_pro !== key_pro) {
          if(p_pro.classList.contains('active-faq')){
            p_pro.classList.remove('active-faq')
            $(p_pro.querySelector('.faq-details-pro')).slideUp()
          }
        } else{
          p_pro.classList.toggle('active-faq')
          $(p_pro.querySelector('.faq-details-pro')).slideToggle()
        }
      })
    }))

  }
})

